import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import { extractSiteGroupingProps } from '@hotjar/webapp/tracking/utils';
import type { TrackingSite } from '@hotjar/webapp/tracking/utils';
import { tagRecording } from '@hotjar/webapp/tracking/tools/hotjar';
import type { OrganizationSizeValue } from '@hotjar/webapp/hooks/useOrganizationSizeChoices';
import type { Role } from '@hotjar/webapp/features/Activation/OnboardingPage/steps/OrganizationSteps/steps/OrganizationRole';

export const trackOrgNameSubmitted = (site?: TrackingSite): void => {
  const data = {
    ...(site && extractSiteGroupingProps(site)),
  };

  tagRecording('org-name_submitted');
  Segment.track('Org-name submitted', data);
};

interface OrgSizeSubmittedArgs {
  site?: TrackingSite;
  orgSize: OrganizationSizeValue;
}

export const trackOrgSizeSubmitted = ({ orgSize, site }: OrgSizeSubmittedArgs): void => {
  const data = {
    ...(site && extractSiteGroupingProps(site)),
    ...(orgSize && { org_size: orgSize }),
  };

  tagRecording('org-size_submitted');
  Segment.track('Org-size submitted', data);
};

interface UserRoleSubmittedArgs {
  site?: TrackingSite;
  role: Role;
}

export const trackUserRoleSubmitted = ({ role, site }: UserRoleSubmittedArgs): void => {
  const data = {
    ...(site && extractSiteGroupingProps(site)),
    ...(role && { user_role: role }),
  };

  tagRecording('user-role_submitted');
  Segment.track('Role details submitted', data);
};
